import type { CityConfig } from "../city-template/types";

export const herndonVaConfig: CityConfig = {
  city: "Herndon",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "herndon-va",
  route: "/cities/herndon-va",
  title: "Emergency Passport Herndon VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Herndon, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Herndon, Fairfax County, and the Dulles corridor. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Herndon, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Fairfax County, Reston, or Sterling? We help Herndon travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Herndon%20Virginia%20charming%20historic%20downtown%20with%20the%20iconic%20Herndon%20Depot%20Museum%20and%20the%20historic%20town%20center%2C%20the%20W%20and%20OD%20trail%20running%20through%20the%20area%2C%20modern%20suburban%20Fairfax%20County%20neighborhoods%20with%20mature%20trees%2C%20the%20Dulles%20corridor%20tech%20atmosphere%20visible%20in%20the%20background%2C%20warm%20afternoon%20light%20with%20a%20classic%20small-town%20Virginia%20main%20street%20aesthetic%2C%20the%20historic%20Herndon%20Theatre%20and%20the%20town%20clock%20tower%20visible%2C%20no%20people%20visible%2C%20professional%20photography%20showcasing%20the%20picturesque%20suburban%20town%20in%20the%20Dulles%20corridor%2C%20Fairfax%20County%2C%20Virginia%20with%20green%20landscape%20and%20modern%20suburban%20homes&width=1800&height=700&seq=herndon-va-hero-001&orientation=landscape",
  heroImageAlt: "Herndon Virginia historic downtown with Depot Museum and charming main street in the Dulles corridor",
  geoPosition: "38.9696;-77.3861",
  geoPlacename: "Herndon, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 30 miles southeast of Herndon via the Dulles Toll Road",
  },
  nearbyCitiesZips: [
    { name: "Herndon", zips: "20170, 20171, 20172" },
    { name: "Reston", zips: "20190, 20191, 20194, 20195, 20196" },
    { name: "Sterling", zips: "20163, 20164, 20165, 20166, 20167" },
    { name: "Chantilly", zips: "20151, 20152, 20153" },
    { name: "Centreville", zips: "20120, 20121" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22035, 22037, 22038, 22039" },
    { name: "Vienna", zips: "22180, 22181, 22182, 22183, 22185" },
    { name: "Oakton", zips: "22124, 22181" },
    { name: "Great Falls", zips: "22066" },
    { name: "McLean", zips: "22101, 22102, 22106, 22107" },
    { name: "Tysons", zips: "22102, 22182, 22185" },
    { name: "Leesburg", zips: "20175, 20176, 20177, 20178" },
    { name: "Ashburn", zips: "20146, 20147, 20148, 20149" },
    { name: "Manassas", zips: "20108, 20109, 20110, 20111, 20112, 20113" },
    { name: "Springfield", zips: "22150, 22151, 22152, 22153, 22156, 22158, 22159, 22160, 22161" },
    { name: "Alexandria", zips: "22301, 22302, 22303, 22304, 22305, 22306, 22307, 22308, 22309, 22310, 22311, 22312, 22314, 22315, 22320, 22331, 22332, 22333, 22334, 22350, 22336" },
    { name: "Winchester", zips: "22601, 22602, 22603, 22604" },
    { name: "Fredericksburg", zips: "22401, 22402, 22404, 22405, 22406, 22407, 22408, 22412" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from Fairfax County" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Dulles Corridor Hub", desc: "Serving Herndon, Reston, Chantilly, and the greater Dulles corridor" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Reston VA passport services", route: "/cities/reston-va" },
    { name: "Leesburg VA passport services", route: "/cities/leesburg-va" },
    { name: "Fairfax VA passport services", route: "/cities/fairfax-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Herndon remotely via secure courier. We do not have a walk-in office in Herndon — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Herndon and Dulles corridor travelers.",
  fpcOfficeDistance: "Serving all of Herndon and the Dulles corridor including Reston, Chantilly, Centreville, Sterling, Fairfax, Vienna, and McLean",
  serviceAreaIntro: "From the historic depot district of downtown Herndon to the modern neighborhoods near the Dulles corridor, from the bustling retail centers along Elden Street to the quiet residential communities near the W and OD Trail, from the tech corridors near Reston to the suburban enclaves of Chantilly and Centreville — Fast Passport Center serves every corner of Herndon and the Dulles corridor. We regularly help travelers from Reston, Fairfax, Vienna, and McLean get their passports fast.",
  nearbyCitiesIntro: "We serve all Herndon neighborhoods and the Dulles corridor including Reston, Chantilly, Centreville, Sterling, Fairfax, Vienna, and McLean.",
  howItWorksIntro: "Most Herndon travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Herndon travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Herndon and Fairfax County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Herndon? Here are the most common ones we hear from Fairfax County travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Herndon international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer H.",
      location: "Herndon, VA",
      rating: 5,
      text: "I needed an emergency passport for a business trip to Singapore with only 5 days notice. Fast Passport Center had my passport in 3 days. I shipped from the UPS Store on Elden Street and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Michael S.",
      location: "Reston, VA",
      rating: 5,
      text: "As a Reston resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for Fairfax County families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Laura T.",
      location: "Chantilly, VA",
      rating: 5,
      text: "First passports for my two children before a family trip to Italy. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 6 days. For Chantilly families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Robert D.",
      location: "Herndon, VA",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to London. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my career and my international trip. Dulles corridor professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "herndon-va-1",
      name: "Herndon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "601 Wilkes St",
      city: "Herndon",
      state: "VA",
      zip: "20170",
      phone: "(703) 437-2021",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Historic Downtown Herndon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Herndon facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "herndon-va-2",
      name: "Reston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11110 Sunset Hills Rd",
      city: "Reston",
      state: "VA",
      zip: "20190",
      phone: "(703) 437-0300",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Reston, south of Herndon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves the Reston area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "herndon-va-3",
      name: "Chantilly Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "14500 Creek Branch Way",
      city: "Chantilly",
      state: "VA",
      zip: "20151",
      phone: "(703) 222-0702",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chantilly, south of Herndon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves the Chantilly area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "herndon-va-4",
      name: "Sterling Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "209 S Maple Ave",
      city: "Sterling",
      state: "VA",
      zip: "20164",
      phone: "(703) 430-5381",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Sterling, west of Herndon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Sterling and Cascades area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "herndon-va-5",
      name: "Fairfax County Clerk",
      type: "County Clerk",
      address: "4110 Chain Bridge Rd",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Fairfax, south of Herndon",
      website: "https://www.fairfaxcounty.gov/courts/circuit",
      websiteLabel: "Fairfax County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "herndon-va-6",
      name: "Leesburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Cornwall St NW",
      city: "Leesburg",
      state: "VA",
      zip: "20176",
      phone: "(703) 771-2624",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Leesburg, northwest of Herndon",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Loudoun County seat. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30+ minute drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Herndon photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Fairfax County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Herndon applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Herndon families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Herndon travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Herndon or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Herndon address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Herndon before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Herndon for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from Fairfax County." },
    { q: "How fast can I renew my passport in Herndon?", a: "Fast Passport Center offers fast passport renewal in Herndon in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Herndon?", a: "The nearest regional passport agency to Herndon is the Washington Passport Agency, located approximately 30 miles southeast in downtown Washington, DC. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Herndon." },
    { q: "Can I get a same-day passport appointment near Herndon?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Herndon residents." },
    { q: "Can I expedite a child passport in Herndon?", a: "Yes. Fast Passport Center expedites child passports in Herndon for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Fairfax County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Herndon with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Herndon?", a: "With Fast Passport Center's emergency courier service, Herndon travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Herndon?", a: "Popular options include the Herndon Post Office (20170), Reston Post Office (20190), Chantilly Post Office (20151), and Sterling Post Office (20164). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Reston, Chantilly, or Centreville?", a: "We serve the entire Dulles corridor including Reston, Chantilly, Centreville, Sterling, Fairfax, Vienna, and McLean. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Herndon?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Herndon", address: "12900 Worldgate Dr, Herndon, VA 20170", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Herndon", address: "605 Elden St, Herndon, VA 20170", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Herndon", address: "13884 Metrotech Dr, Chantilly, VA 20151", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Reston", address: "11981 Market St, Reston, VA 20190", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Sterling", address: "209 S Maple Ave, Sterling, VA 20164", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Chantilly", address: "14514 Lee Jackson Memorial Hwy, Chantilly, VA 20151", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Herndon",
      address: "850 Lee Jackson Memorial Hwy, Chantilly, VA 20151",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Reston",
      address: "1416 Northpoint Village Center, Reston, VA 20194",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Fairfax",
      address: "10310 Main St, Fairfax, VA 22030",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Fairfax County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "IAD",
      name: "Dulles International Airport",
      distance: "Approximately 10 miles east of Herndon",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "The closest international airport to Herndon. Major international hub. Accessible via the Dulles Toll Road.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: true,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 30 miles southeast of Herndon",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "Domestic hub near DC. Accessible via the Dulles Toll Road and I-66.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "Approximately 55 miles northeast of Herndon",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Regional hub for Baltimore and DC area. Accessible via Route 7 and I-270.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};